import React from 'react';
import MomentUtils from '@date-io/moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(() => ({
  selectedDate: {
    '& .MuiPickersDay-daySelected': {
      background: '#296690 !important',
      color: '#ffffff !important',
    },
  },
  dateInPattern: {
    '& .MuiPickersDay-day': {
      border: '3px solid #296690',
      height: '30px',
      width: '30px',
    },
  },
  dateAvailable: {
    '& .MuiPickersDay-day': {
      background: '#BAE2E7',
      color: '#000000',
    },
  },
  conflictInPattern: {
    '& .MuiPickersDay-day': {
      background: '#F39D9D',
      color: '#000000',
    },
  },
  dateInConflict: {
    '& .MuiPickersDay-day': {
      background: '#E5E3E3',
      color: '#000000',
    },
  },
}));

export const renderRecurringDatesOnCalendar = (
  day,
  dayComponent,
  availDates,
  datesToCreate,
  recurringDatesWithConflicts,
  classes,
) => {
  let dateClass;
  const matchingDate = availDates?.find(
    (d) => d.date === day.format('YYYY-MM-DD'),
  );

  const dateMatchesPattern = datesToCreate.find((val) =>
    moment(val).isSame(day, 'day'),
  );
  const conflictInPattern = recurringDatesWithConflicts.find((val) =>
    moment(val.date).isSame(day, 'day'),
  );
  // Selected dates/dates in pattern should show red if they have a conflict
  if (conflictInPattern && dateMatchesPattern)
    dateClass = `${classes.dateInPattern} ${classes.conflictInPattern}`;
  // If a date has a conflict but is not selected, show as light grey
  if (!conflictInPattern && matchingDate)
    dateClass = `${classes.selectedDate} ${
      matchingDate.is_available ? classes.dateAvailable : classes.dateInConflict
    }`;
  // If a date with a conflict has been removed from the list, show as light grey
  if (conflictInPattern && !dateMatchesPattern) {
    dateClass = classes.dateInConflict;
  }
  // Selected days/dates in pattern should show blue
  if (!conflictInPattern && dateMatchesPattern)
    dateClass = `${dateClass} ${classes.dateInPattern}`;

  if (matchingDate?.unavailable_reason) {
    return (
      <Tooltip title={matchingDate.unavailable_reason || null}>
        <Box className={dateClass}>{dayComponent}</Box>
      </Tooltip>
    );
  }
  return <Box className={dateClass}>{dayComponent}</Box>;
};

const RecurringPlanCalendar = ({
  rruleAttributes,
  onRruleChange,
  serviceVehicleDates,
  datesToCreate,
  datesWithConflicts,
}) => {
  const classes = useStyles();

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <DatePicker
        autoOk
        variant="static"
        openTo="date"
        value={rruleAttributes.dtstart}
        onChange={(val) =>
          onRruleChange(
            'dtstart',
            new Date(`${val.format('YYYY-MM-DD')}T00:00:00`),
          )
        }
        disableToolbar
        shouldDisableDate={(date) =>
          !serviceVehicleDates
            ?.map((d) => d.date)
            .includes(date.format('YYYY-MM-DD'))
        }
        renderDay={(day, selectDate, isInCurrentMonth, dayComponent) => {
          return renderRecurringDatesOnCalendar(
            day,
            dayComponent,
            serviceVehicleDates,
            datesToCreate,
            datesWithConflicts,
            classes,
          );
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default RecurringPlanCalendar;
